import { Outlet } from 'react-router'
import React from 'react'

const CatalogTransferLayout = () => (
    <>
        <title>Catalog Transfer Tool</title>
        <Outlet />
    </>
)

export default CatalogTransferLayout
